import { Controller } from "@hotwired/stimulus"

// Locks submit controls once Turbo starts submitting a form.
// This prevents repeated clicks while keeping normal form fields enabled.
export default class extends Controller {
  static values = {
    text: { type: String, default: "En cours..." }
  }

  connect() {
    this.locked = false
    this.lockedControls = []

    this.handleSubmit = this.handleSubmit.bind(this)
    this.lock = this.lock.bind(this)
    this.unlockOnFailure = this.unlockOnFailure.bind(this)

    this.element.addEventListener("submit", this.handleSubmit)
    this.element.addEventListener("turbo:submit-start", this.lock)
    this.element.addEventListener("turbo:submit-end", this.unlockOnFailure)
  }

  disconnect() {
    this.element.removeEventListener("submit", this.handleSubmit)
    this.element.removeEventListener("turbo:submit-start", this.lock)
    this.element.removeEventListener("turbo:submit-end", this.unlockOnFailure)
  }

  handleSubmit(event) {
    if (!this.locked) return

    event.preventDefault()
    event.stopImmediatePropagation()
  }

  lock() {
    if (this.locked) return

    this.locked = true
    this.element.setAttribute("aria-busy", "true")
    this.lockedControls = this.submitControls.map((control) => {
      const state = {
        control,
        disabled: control.disabled,
        value: control.value,
        textContent: control.textContent
      }

      control.disabled = true

      if (control.matches("input[type='submit']")) {
        control.value = this.textValue
      } else {
        control.textContent = this.textValue
      }

      return state
    })
  }

  unlockOnFailure(event) {
    if (event.detail.success) return

    this.locked = false
    this.element.removeAttribute("aria-busy")

    this.lockedControls.forEach(({ control, disabled, value, textContent }) => {
      control.disabled = disabled

      if (control.matches("input[type='submit']")) {
        control.value = value
      } else {
        control.textContent = textContent
      }
    })

    this.lockedControls = []
  }

  get submitControls() {
    return Array.from(this.element.querySelectorAll("input[type='submit'], button[type='submit'], button:not([type])"))
  }
}
